import classname from 'classnames'
import rem from '@/utils/rem'
import Loader from 'react-loader-spinner'

/**
 * @deprecated Use `Button` from `@dextech-ai/dex-design-system` instead.
 * Do not add new call sites.
 */
const Button = ({ loading, prefix, suffix, text, submit, warning, ghost, border, round, error, noborder, reject, success, image, full, sizing = 'default', maxWidth, noHover, addClass, selected, ascent, ...btnProps }) => {

	const sizingOptions = {
		DEFAULT: 'default',
		MEDIUM: 'medium',
		MINI: 'mini',
		CIRCLE: 'circle',
	}

	const btnStyles = {
		...btnProps.style,
		maxWidth: rem(maxWidth)
	}

	const btnClass = classname(
		addClass,
		{
			'button--reset': warning,
			'button--full': full,
			'button--ghost': ghost,
			'button--ascent': ascent,
			'button--ascent--selected': ascent && selected,
			'button--border': border,
			'button--border--no-hover': border && noHover,
			'button--medium': sizing === sizingOptions.MEDIUM,
			'button--mini': sizing === sizingOptions.MINI,
			'button--circle': sizing === sizingOptions.CIRCLE,
			'button--no-border': noborder,
			'button--rounded': round,
			'button--reject': reject,
			'button--success': success,
			'button--error': error,
		}
	)

	const Prefix = () => {
		if (prefix) {
			return (
				<>
					{prefix}<span style={{ marginLeft: rem(8) }}></span>
				</>
			)
		}
		return ''
	}

	const Suffix = () => {
		if (suffix) {
			return (
				<>
					<span style={{ marginLeft: rem(8) }}></span>{suffix}
				</>
			)
		}
		return ''
	}

	return (
		<button {...btnProps} className={btnClass} style={btnStyles} onClick={submit ? (loading ? null : submit) : null}>
			{loading ? <Loader type="ThreeDots" color={ghost ? "#a614b9" : "#ffffff"} height={10} width={15} /> : (<><Prefix />{text}<Suffix /></>)}
		</button>
	)
}

export default Button
